import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL, 
  withCredentials: true,
  headers: {
    "Content-Type": "application/json", 
  }
});

api.interceptors.request.use((config) => {
  const method = config.method?.toUpperCase();
  const needsCsrfHeader = ['POST', 'PUT', 'DELETE', 'PATCH'].includes(method);
  
  if (needsCsrfHeader) {
    config.headers['X-App-Intent'] = 'true';
  }

  return config;
});

api.getTrips = async () => {
    try {
      const response = await api.get("/PublicTrips"); 
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  api.resolvePriority = async (key) => {
    try {
      const response = await api.get(`/PublicTrips/resolve/${key}`);
      return response.data;
    } catch (error) {
      throw error; 
    }
  };

  api.getTrip = async (tripGuid) => {
    try {
      const response = await api.get(`/PublicTrips/${tripGuid}`);
      return response.data;
    } catch (error) {
      throw error; 
    }
  };

  api.checkIfRegistrationIsActive = async (code, searchParams) => {
    try {
      const search = searchParams?.toString(); 
      const url = `/PublicTrips/${code}/checkStatus${search ? `?${search}` : ''}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  api.getVariant = async (tripGuid, variantGuid, searchParams) => {
    try {
      const search = searchParams.toString();
      const url = `/PublicTrips/${tripGuid}/${variantGuid}${search ? `?${search}` : ''}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  api.makePrereservation = async (variantCode, preReservation, searchParams) => {
    try {
      const search = searchParams?.toString();
      const url = `/Reservations/${variantCode}${search ? `?${search}` : ''}`;
      return api.post(url, preReservation).then(response => response.data);
    } catch (error) {
      throw error; 
    }
  }

  api.finishPrereservation = async (reservationGuid, data) => {
    try {
      const response = await api.post(`/Reservations/${reservationGuid}/finish`, data);
      return response.data;
    } catch (error) {
      throw error; 
    }
  }

  api.resumePrereservation = async (reservationGuid) => {
  try {
    const response = await api.get(`/Reservations/${reservationGuid}/resume`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

  api.getWaitingListStatus = async (reservationGuid) => {
  try {
    const response = await api.get(`/PublicWaitingList/${reservationGuid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default api;
